// extracted by mini-css-extract-plugin
export default {"spaceAround":"LnhaOKVGx13DLnPxB5h3","amount":"XItElSJJiU6hmi5VnoFx"};